
export default {
  props: {
    showConfirmationDialog: Boolean,
    bankingInfo: Object
  },
  methods: {
    accountConfirmed() {
      this.$emit("close-dialog");
      this.$nuxt.$emit("show-advance-payment-transfer");
    }
  }
};
